"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var BaseModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, content = _a.content, footer = _a.footer, headerClassName = _a.headerClassName, bodyClassName = _a.bodyClassName, footerClassName = _a.footerClassName, closeIconClassName = _a.closeIconClassName, modalClassName = _a.modalClassName;
    return (react_1.default.createElement(react_responsive_modal_1.default, { open: isOpen, onClose: onClose, center: true, showCloseIcon: false, classNames: {
            modal: modalClassName
        } },
        react_1.default.createElement("div", { className: headerClassName },
            title,
            closeIconClassName && (react_1.default.createElement("button", { onClick: onClose, className: closeIconClassName, "aria-label": "Close" }, "\u00D7"))),
        react_1.default.createElement("div", { className: bodyClassName }, content),
        react_1.default.createElement("div", { className: footerClassName }, footer)));
};
exports.default = BaseModal;
